function emailToKey(email: string): string {
  return email.split(".").join("_dot_");
}

export default emailToKey;
